import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IDeposcoCredentials {
    username: string,
    password: string,
    tenantCode: string;
    businessUnit: string;
}

class DeposcoCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IDeposcoCredentials = {} as IDeposcoCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }

    public set username(v: string) { this._changes.username = v; }

    public get password() { return this._changes.password; }

    public set password(v: string) { this._changes.password = v; }

    public get tenantCode() { return this._changes.tenantCode; }

    public set tenantCode(v: string) { this._changes.tenantCode = v; }

    public get businessUnit() { return this._changes.businessUnit; }

    public set businessUnit(v: string) { this._changes.businessUnit = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IDeposcoCredentials;
    }

    public getUpdatedModel(): IDeposcoCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default DeposcoCredentialsStore;